import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/335'

const AverageRevenuePerLocationPerMonthTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="revenue.tabs.average_revenue_per_location_per_month"
  />
)

export default AverageRevenuePerLocationPerMonthTab
